import classNames from 'classnames';
import { ReactNode } from 'react';

type TextAlignProps = 'start' | 'center' | 'end' | 'justify';

type SectionProps = {
  textAlign?: TextAlignProps;
  end?: boolean;
  children?: ReactNode;
  className?: string;
};

function Section({ textAlign = 'start', end = false, children, className }: SectionProps) {
  return (
    <div className={classNames('p-3', { 'border-b-2': !end }, `text-${textAlign}`, className)}>
      {children}
    </div>
  );
}

export default Section;
